import React, {useState} from 'react';
import {NavLink, Route, Routes} from "react-router-dom";
import Amudaryo from './amudaryo/index'
import Sirdaryo from './sirdaryo/index'
import ContentTop from "../../../components/ContentTop";
function Index(props) {
    const [menu, setMenu] = useState(1)
    return (
        <>
            <ContentTop>
            <ul className="content-top-left in-menu">
                <li>PTN</li>
                <li className={menu==1?'active':''}>
                    <NavLink to="/limit/daryolar/amudaryo" onClick={()=>setMenu(1)}>Amudaryo</NavLink>
                </li>
                <li className={menu==2?'active':''}>
                    <NavLink to="/limit/daryolar/sirdaryo" onClick={()=>setMenu(2)}>Sirdaryo</NavLink>
                </li>
            </ul>
            </ContentTop>
            <div className="tabs-content table-box">
                <div className="tabs-content-item active">
                    <Routes>
                        <Route path="/*" element={
                            <Amudaryo />
                        }/>
                        <Route path="/sirdaryo/*" element={
                            <Sirdaryo />
                        }/>
                        <Route path="/amudaryo/*" element={
                            <Amudaryo />
                        }/>
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default Index;